/*!
 * HaiKom API JavaScript Library.
 *
 * Copyright (C) HaiKom AB 2007-2017
 */
;(function($, window, document, undefined) {
	'use strict';

	$(document).ready(function () {
		$('[data-switch-language]').off('click').click(function (e) {
			var body = $('body');
			var self = $(this);

			var projectName = body.attr('data-project-name');
			var languageCode = self.attr('data-switch-language');

			try {
				var url = '/' + projectName + '/Language/' + languageCode;
				$.post(url)
					.done(function (data) {
						if (data &&
							data.oldlanguage &&
							data.newlanguage &&
							data.oldlanguage !== data.newlanguage) {
							window.location.reload(true);
						}
					})
					.fail(function (error) {
						if (error) {
							console.error(error.status + ' (' + error.statusText + '): ' + error.responseText);
						}
					});
			}
			catch (ex) {
				console.error(ex);
			}

			e.preventDefault();
		});
	});
})(jQuery, window, document, undefined);
